function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#FFF",
  strokeLinecap: "square",
  d: "M19.5 41.5v68.066m7-68.066v68.066"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#FFF",
  d: "M7.5 3.773v33.586c2.976 2.804 8.139 4.225 15.5 4.225 7.361 0 12.524-1.421 15.5-4.225V3.773C35.57 1.603 30.4.5 23 .5S10.43 1.604 7.5 3.773zm41 70.983V13a2 2 0 114 0v61.756"
}), /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 36,
  x: 38.5,
  y: 74.5,
  stroke: "#FFF",
  rx: 12
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M77.862 101.791c-9.56 0-9.58-5.791-19.19-5.791-9.61 0-9.59 5.791-19.178 5.791-9.588 0-9.574-5.791-19.148-5.791s-9.598 5.666-19.176 5.791C.68 101.798 1.11 118 1.11 118H77.88s.281-16.209-.018-16.209z",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#FFF",
  strokeLinecap: "square",
  d: "M38.5 21.5h9.055"
}));

function SvgRoomSumpPump(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78,
    height: 118,
    viewBox: "0 0 78 118",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomSumpPump);
export default __webpack_public_path__ + "static/media/RoomSumpPump.e4eeea8a.svg";
export { ForwardRef as ReactComponent };